import React from 'react';
import { Edit2Icon, Trash2Icon } from 'lucide-react';
const mockUsers = [{
  id: 1,
  name: 'Juan Pérez',
  identification: '12345678',
  email: 'juan.perez@example.com',
  partner: 'Aliado A',
  status: true
}, {
  id: 2,
  name: 'María García',
  identification: '87654321',
  email: 'maria.garcia@example.com',
  partner: 'Aliado B',
  status: false
}];
export const BackofficeTable = ({
  onEdit
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-104">
      <div className="overflow-x-auto" data-id="element-105">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-106">
          <thead className="bg-gray-50" data-id="element-107">
            <tr data-id="element-108">
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-109">
                Nombre
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-110">
                Identificación
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-111">
                Correo
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-112">
                Aliado Asignado
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-113">
                Estado
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-114">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-115">
            {mockUsers.map((user, index) => <tr key={user.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-116">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-117">
                  <div className="text-sm font-medium text-gray-900" data-id="element-118">
                    {user.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-119">
                  <div className="text-sm text-gray-500" data-id="element-120">
                    {user.identification}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-121">
                  <div className="text-sm text-gray-500" data-id="element-122">{user.email}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-123">
                  <div className="text-sm text-gray-900" data-id="element-124">{user.partner}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-125">
                  <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${user.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-126">
                    {user.status ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-127">
                  <div className="flex space-x-3" data-id="element-128">
                    <button onClick={() => onEdit(user)} className="text-blue-600 hover:text-blue-900" data-id="element-129">
                      <Edit2Icon className="h-5 w-5" data-id="element-130" />
                    </button>
                    <button className="text-red-600 hover:text-red-900" data-id="element-131">
                      <Trash2Icon className="h-5 w-5" data-id="element-132" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};